<template>
    <div>
        <div class="card card-custom gutter-b">
            <div class="card-header">
                <div class="d-flex flex-row w-100 align-items-center mt-7">
                    <div class="card-title flex-fill">
                        <h3 class="card-label">
                            <i class="fas fa-plus-square"></i> {{ __('actions.add_brand') }}
                        </h3>
                    </div>
                    <div class="d-flex flex-row align-items-center">
                        <span class="text-muted mr-2">{{ __('actions.show.index') }}: </span>
                        <select class="form-control form-control-sm" v-model="showFound">
                            <option value="10">10</option>
                            <option value="25" selected>25</option>
                            <option value="50">50</option>
                            <option value="1000000">{{ __('general.everything') }}</option>
                        </select>
                    </div>
                </div>
                <p class="text-muted">{{ __('brand.add_brands') }}</p>
            </div>
            <div class="card-body">
                <label>{{ __('actions.select_brand') }}</label>
                <input v-model="brandEntry" @keyup="searchBrand" type="text" class="form-control"
                       placeholder="z.B. Nike">
                <span class="form-text text-muted" v-show="foundBrands.length === 0 && brandEntry.length < 2">
                        {{ __('brand.add_brands') }}
                    </span>
                <span class="form-text text-muted" v-show="brandEntry.length > 2">
                    {{ __('brand.brand_not_displayed') }} <a href="javascript:void(0);" @click="createBrand">{{ __('actions.create_brand') }}</a>
                </span>
                <div class="mt-2">
                    <button type="button" class="btn btn-outline-secondary mb-2 mt-2 mr-2"
                            v-for="brand in sortedFoundBrands"
                            @click="add(brand['name'],brand['uuid'])"><i
                        class="fas fa-plus-square text-primary"></i> <strong>{{ brand['name'] }}</strong></button>
                </div>
                <div v-show="foundBrands.length > showFound" class="text-primary text-center mt-4">
                    <strong>+ {{ foundBrands.length - showFound }} {{ __('brand.not_displayed') }}</strong><br>
                    <button class="btn-primary btn btn-sm mt-2 px-4" @click="showFound = 1000000" type="button">
                        <i class="fas fa-chevron-circle-down"></i> {{ __('actions.show.all') }}
                    </button>
                </div>
            </div>
        </div>


        <div class="card card-custom mt-4 gutter-b">
            <div class="card-header">
                <div class="card-title">
                    <h3 class="card-label">
                        <i class="fa fa-bookmark"></i> {{ __('brand.selected_brands') }}
                    </h3>
                </div>
                <div class="card-toolbar">
                    <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="fas fa-search"></i></span>
                        </div>
                        <input v-model="searchEntry" type="text" class="form-control form-control-sm"
                               :placeholder="__('actions.search')">
                    </div>
                </div>
            </div>
            <div class="card-body">
                <div class="row">
                    <div class="col-lg-4 col-md-6 mb-2 p-2" v-for="brand in newBrands"
                         v-show="brandNameMatchesFilter(brand)">
                        <div class="row">
                            <div class="col-6">
                                {{ brand }}
                            </div>
                            <div class="col-6">
                                <button @click="removeNewBrand(brand)" type="button"
                                        class="btn btn-light-primary btn-xs"><i class="fa fa-times"></i> {{ __('actions.remove') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-6 mb-2 p-2" v-for="brand in getSortedSelected"
                         v-show="brandNameMatchesFilter(brand)">
                        <div class="row">
                            <div class="col-6">
                                {{ brand.name }}
                            </div>
                            <div class="col-6">
                                <button @click="remove(brand.uuid)" type="button" class="btn btn-light-primary btn-xs">
                                    <i class="fa fa-times"></i> {{ __('actions.remove') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <slot></slot>
            </div>
        </div>

        <input type="hidden" name="brand_uuids[]" v-for="brand in selected" :value="brand.uuid">
        <input type="hidden" name="new_brands[]" v-for="brand in newBrands" :value="brand">
    </div>
</template>

<script>
export default {
    name: 'BrandSelection',

    props: {
        brands: Array,
        loadSelected: Array,
    },

    data() {
        return {
            brandEntry: '',
            searchEntry: '',
            foundBrands: [],
            selected: [],
            newBrands: [],
            showFound: 25,
        };
    },

    mounted() {
        this.selected = this.loadSelected;
    },

    computed: {
        sortedFoundBrands() {
            return this.foundBrands.sort((a, b) => {
                let distanceA = this.levenshtein(a.name.toLowerCase(), this.brandEntry.trim().toLowerCase());

                if (distanceA === 0) {
                    return -1;
                }

                return this.levenshtein(b.name.toLowerCase(), this.brandEntry.trim().toLowerCase());
            }).slice(0, this.showFound);
        },

        getSortedSelected() {
            return this.selected.sort((a, b) => {
                return a.name < b.name ? -1 : 1;
            });
        },
    },

    methods: {
        brandNameMatchesFilter(brand) {
            return (this.searchEntry.length === 0 ||
                brand.name.toLowerCase().replace('[^A-Za-z0-9]', '').includes(this.searchEntry.toLowerCase()));
        },

        searchBrand() {
            if (this.brandEntry.length > 1) {
                let found = [];
                for (let brand of this.brands) {
                    if (!brand['name'].toLowerCase().
                        replace('[^A-Za-z0-9]', '').
                        includes(this.brandEntry.trim().toLowerCase())) {
                        continue;
                    }

                    let exists = false;
                    for (let s of this.selected) {
                        if (s.name === brand.name) {
                            exists = true;
                        }
                    }

                    if (exists) {
                        continue;
                    }

                    found.push(brand);
                }
                this.foundBrands = found;
            } else {
                this.foundBrands = [];
            }
        },

        createBrand() {
            let brandName = this.brandEntry.trim();

            if (brandName.length <= 1) {
                toastr.warning('Der Markenname muss länger als 1 Zeichen sein.');
                return;
            }

            let alreadyAdded = false;
            for (let brand of this.selected){
                if (brand.name === brandName){
                    toastr.warning('Die Marke wurde bereits hinzugefügt.');
                    return;
                }
            }

            axios.post(this.$route('ajax.brands.create'), {
                name: brandName
            }).then(response => {
                let newBrand = response.data.data;

                if(!this.brands.includes(newBrand)){
                    this.brands.push(newBrand);
                    this.selected.push(newBrand);
                }

                this.brandEntry = '';
                this.foundBrands = [];
            }, errorsResponse => {
                console.log('error', errorsResponse);
            });
        },

        add(brandName, brandUuid) {
            let brand = [];
            brand['name'] = brandName;
            brand['uuid'] = brandUuid;
            this.selected.push(brand);
            this.brandEntry = '';
            this.foundBrands = [];
        },

        remove(brandUuid) {
            let newSelected = [];
            for (let s of this.selected) {
                if (s.uuid !== brandUuid) {
                    newSelected.push(s);
                }
            }

            this.selected = newSelected;
        },

        removeNewBrand(brandName) {
            let newNewBrands = [];
            for (let newBrand of this.newBrands) {
                if (newBrand !== brandName) {
                    newNewBrands.push(newBrand);
                }
            }

            this.newBrands = newNewBrands;
        },

        levenshtein(a, b) {
            if (a.length === 0) return b.length;
            if (b.length === 0) return a.length;

            // swap to save some memory O(min(a,b)) instead of O(a)
            if (a.length > b.length) {
                var tmp = a;
                a = b;
                b = tmp;
            }

            let row = [];
            // init the row
            for (let i = 0; i <= a.length; i++) {
                row[i] = i;
            }

            // fill in the rest
            for (let i = 1; i <= b.length; i++) {
                var prev = i;
                for (var j = 1; j <= a.length; j++) {
                    var val;
                    if (b.charAt(i - 1) === a.charAt(j - 1)) {
                        val = row[j - 1]; // match
                    } else {
                        val = Math.min(row[j - 1] + 1, // substitution
                            prev + 1,     // insertion
                            row[j] + 1);  // deletion
                    }
                    row[j - 1] = prev;
                    prev = val;
                }
                row[a.length] = prev;
            }

            return row[a.length];
        },
    },
};
</script>
